import React from 'react';
import questionareStyle from '../../style';
import FullName from '../FullName';

export default function Slide1(props) {
	let style = questionareStyle();
	return (
		<div>
			<p
				style={{
					...{
						marginTop: '1rem',
					},
					...style.questionareText(),
				}}
			>
				What is your full name
			</p>
			<FullName
				nextPressed={(first, last) => {
					if (!first) {
						alert('You must provide at least a first name');
						return;
					}
					props.nextPressed({
						name: {
							first: first,
							last: last,
						},
					});
				}}
			/>
		</div>
	);
}
